<template>
	<div class="d-flex align-center justify-center flex-column">
		<div class="w-85">
			<botao-voltar
				class="mb-5"
				label-voltar="voltar para listagem"
				:nome-rota-anterior="rotaListagem"
			></botao-voltar>
			<cabecalho-ata-view></cabecalho-ata-view>
			<cadastro-solicitante-view></cadastro-solicitante-view>
			<pesquisa-itens-adesao-view></pesquisa-itens-adesao-view>
			<justificativa-adesao-view></justificativa-adesao-view>
			<anexo-solicitante-view></anexo-solicitante-view>
		</div>
	</div>
</template>

<script>
import CabecalhoAtaView from '@/views/pages/ata/pesquisa/acessar/cabecalho/CabecalhoAtaView.vue'
import BotaoVoltar from '@/views/components/BotaoVoltar.vue'
import { routesNames } from '@/core/constants'
import CadastroSolicitanteView from '@/views/pages/adesao/publica/cadastro-solicitante/CadastroSolicitanteView.vue'
import PesquisaItensAdesaoView from '@/views/pages/adesao/publica/itens/PesquisaItensAdesaoView.vue'
import JustificativaAdesaoView from '@/views/pages/adesao/publica/justificativa/JustificativaAdesaoView.vue'
import AnexoSolicitanteView from '@/views/pages/adesao/publica/anexos/AnexoSolicitanteView.vue'

export default {
	name: 'adesao-publica-view',
	components: {
		AnexoSolicitanteView,
		JustificativaAdesaoView,
		PesquisaItensAdesaoView,
		CadastroSolicitanteView,
		BotaoVoltar,
		CabecalhoAtaView,
	},
	mixins: [],
	data() {
		return {
			rotaListagem: routesNames.ATA.ATA_VIEW,
		}
	},
	computed: {},
	methods: {},
}
</script>
<style scoped lang="stylus">
.w-85
	width: 85%
</style>
